import axios from 'axios';
import store from './store';
import moment from 'moment';

const Apiv2 = axios.create({
  baseURL: process.env.VUE_APP_API_URL_KARYAWAN,
  headers: {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': 'Authorization',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  mode: 'no-cors',
  credentials: true,
  crossdomain: true,
});

let apiConfig = {};
Apiv2.interceptors.request.use(
  (config) => {
    apiConfig = config;
    const LocalDataVuex =
      localStorage.getItem('amanah') &&
      localStorage.getItem('amanah') !== 'undefined'
        ? JSON.parse(localStorage.getItem('amanah'))
        : false;

    if (LocalDataVuex && LocalDataVuex.access_token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${(LocalDataVuex && LocalDataVuex.access_token
          ? LocalDataVuex.access_token
          : '') || ''}`,
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

Apiv2.interceptors.response.use(
  async (response) => {
    let config = response.config;
    apiConfig = config;

    if (config.url.indexOf('/auth/refreshtoken') !== -1) {
      localStorage.setItem('amanah', JSON.stringify(response.data.object));
    } else {
      const LocalDataVuex =
        localStorage.getItem('amanah') &&
        localStorage.getItem('amanah') !== 'undefined'
          ? JSON.parse(localStorage.getItem('amanah'))
          : false;

      if (
        LocalDataVuex &&
        LocalDataVuex.access_token &&
        LocalDataVuex.expired_time &&
        LocalDataVuex.expired_time !== ''
      ) {
        let timeNow = moment(new Date());
        let timeout = moment(LocalDataVuex.expired_time);
        if (timeNow.diff(timeout, 'minutes') > 15) {
          await Apiv2PostRequest('/auth/refreshtoken');
        }
      }

      return response;
    }
  },
  async (error) => {
    return Promise.reject(error);
  },
);

const ApiBlob = axios.create({
  baseURL: process.env.VUE_APP_API_URL_KARYAWAN,
  headers: {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': 'Authorization',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  mode: 'no-cors',
  credentials: true,
  crossdomain: true,
  responseType: 'blob',
});

ApiBlob.interceptors.request.use(
  (config) => {
    apiConfig = config;
    const LocalDataVuex =
      localStorage.getItem('amanah') &&
      localStorage.getItem('amanah') !== 'undefined'
        ? JSON.parse(localStorage.getItem('amanah'))
        : false;

    if (LocalDataVuex && LocalDataVuex.access_token) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${(LocalDataVuex &&
          LocalDataVuex.access_token) ||
          ''}`,
      };
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

ApiBlob.interceptors.response.use(
  async (response) => {
    let config = response.config;
    apiConfig = config;

    if (config.url.indexOf('/auth/refreshtoken') !== -1) {
      localStorage.setItem('amanah', JSON.stringify(response.data.object));
    } else {
      const LocalDataVuex =
        localStorage.getItem('amanah') &&
        localStorage.getItem('amanah') !== 'undefined'
          ? JSON.parse(localStorage.getItem('amanah'))
          : false;

      if (
        LocalDataVuex &&
        LocalDataVuex.access_token &&
        LocalDataVuex.expired_time &&
        LocalDataVuex.expired_time !== ''
      ) {
        let timeNow = moment(new Date());
        let timeout = moment(LocalDataVuex.expired_time);
        if (timeNow.diff(timeout, 'minutes') > 10) {
          await Apiv2PostRequest('/auth/refreshtoken');
        }
      }

      return response;
    }
  },
  async (error) => {
    return Promise.reject(error);
  },
);

export function showErrorNotification(error) {
  let message =
    (error.response && error.response.data && error.response.data.message) ||
    '';

  let error_data =
    (error.response && error.response.data && error.response.data.errors) ||
    false;

  // kalau ada error unautorize clear localstorage
  if (
    message === 'Unauthorized' &&
    apiConfig &&
    apiConfig.url.indexOf('/auth/refreshtoken') === -1
  ) {
    localStorage.removeItem('amanah');
    window.location.href = '/';
    return false;
  } else {
    if (message === 'Unauthorized') {
      localStorage.removeItem('amanah');
      window.location.href = '/';
      return false;
    } else {
      store.dispatch('notification/showNotif', {
        message:
          message && message !== '' ? message : 'Tidak Dapat Mengakses Data',
        type: 'error',
      });

      return {
        message:
          message && message !== '' ? message : 'Tidak Dapat Mengakses Data',
        error_data,
      };
    }
  }
}

export function Apiv2GetRequest(url, data = {}) {
  return Apiv2.get(url, {
    params: data,
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export function Apiv2BlobGetRequest(url, data = {}) {
  return ApiBlob.get(url, {
    params: data,
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export function Apiv2PostMultipart(url, data = {}) {
  return Apiv2.post(url, data, {
    headers: {
      'content-type': 'multipart/form-data',
    },
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export function Apiv2GetUploadFile(url, data = {}, callbackUpload = () => {}) {
  return Apiv2.post(url, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (event) => callbackUpload(event),
  })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
}

export const Apiv2PostRequest = (url, data = {}) => {
  return Apiv2.post(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};

export const Apiv2PutRequest = (url, data = {}) => {
  return Apiv2.put(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};

export const Apiv2DeleteRequest = (url, data = {}) => {
  return Apiv2.delete(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      const { message, error_data } = showErrorNotification(error);
      return {
        error: message,
        error_data: error_data,
      };
    });
};
